import { render, staticRenderFns } from "./Subnavigation.vue?vue&type=template&id=e134a7d8&"
import script from "./Subnavigation.vue?vue&type=script&lang=ts&"
export * from "./Subnavigation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports